import { RootState } from '../../rootReducer'

export const selectUserPreferences = (state: RootState) => state.userPreferences.preferences
